import { tv } from 'tailwind-variants';
import { colors } from './colors.const';

export const buttonStyles = tv({
  slots: {
    base: [
      'group relative inline-flex select-none items-center justify-center overflow-hidden rounded font-medium',
      'h-10 gap-2 px-6 text-sm cursor-pointer',
      'data-[disabled]:cursor-not-allowed data-[ui-disabled]:[&a]:pointer-events-none data-[loading]:cursor-progress',
      'focus-visible:outline-none'
    ],
    icon: 'group-data-[loading]:invisible shrink-0 size-4',
    text: 'group-data-[loading]:invisible',
    loaderWrapper:
      'absolute inset-0 flex items-center justify-center space-x-2',
    loader: '',
    ripple: 'bg-current',
    overlay: [
      'absolute inset-0 overflow-hidden bg-fixed opacity-0 transition',
      'duration-300 ease-in-out rounded-[inherit] bg-current'
    ]
  },
  variants: {
    variant: {
      filled: {
        base: 'bg-primary text-white shadow-md data-[ui-disabled]:bg-black/10 data-[ui-disabled]:text-black/25',
        overlay: 'bg-white group-hover:opacity-30'
      },
      outlined: {
        base: 'border border-solid border-stroke text-primary data-[ui-disabled]:bg-black/10 data-[ui-disabled]:text-black/25',
        overlay: 'bg-current group-hover:opacity-10'
      },
      toned: {
        base: 'border-none bg-primary/10 text-primary data-[ui-disabled]:bg-black/10 data-[ui-disabled]:text-black/25',
        overlay: 'bg-current group-hover:opacity-10'
      },
      text: {
        base: 'border-none text-primary  data-[ui-disabled]:text-black/25',
        overlay: 'bg-current group-hover:opacity-10'
      }
    },
    color: {
      primary: '',
      secondary: '',
      tertiary: '',
      black: '',
      success: '',
      good: '',
      neutral: '',
      info: '',
      error: '',
      warning: ''
    },
    size: {
      xs: {
        base: 'h-6 gap-1 px-2 text-2xs',
        icon: 'size-3',
        loader: 'size-3'
      },
      sm: {
        base: 'h-8 gap-1.5 px-3 text-xs',
        icon: 'size-3.5',
        loader: 'size-4'
      },
      md: {
        base: 'h-10 gap-2 px-6 text-sm',
        icon: 'size-4',
        loader: 'size-5'
      },
      lg: {
        base: 'h-12 gap-2 px-6 text-base',
        icon: 'size-[18px]',
        loader: 'size-6'
      },
      xl: {
        base: 'h-14 gap-2 px-6 text-lg',
        icon: 'size-[22px]',
        loader: 'size-7'
      }
    },
    rounded: {
      true: 'rounded-full'
    },
    flat: {
      true: 'shadow-none'
    },
    tile: {
      true: 'rounded-none'
    },
    appended: {
      true: ''
    },
    prepended: {
      true: ''
    }
  },
  compoundVariants: [
    // region Filled Variant
    ...colors.map(
      (item) =>
        ({
          color: item.color,
          variant: 'filled',
          class: item.filled
        }) as any
    ),
    // endregion Filled Variant
    // region Toned Variant
    ...colors.map(
      (item) =>
        ({
          color: item.color,
          variant: 'toned',
          class: item.toned
        }) as any
    ),
    // endregion Toned Variant
    // region Outlined Variant
    ...colors.map(
      (item) =>
        ({
          color: item.color,
          variant: 'outlined',
          class: item.outlined
        }) as any
    ),
    // endregion Outlined Variant
    // region Text Variant
    ...colors.map(
      (item) =>
        ({
          color: item.color,
          variant: 'text',
          class: item.text
        }) as any
    ),
    // endregion Text Variant
    // region Prepended Styles
    {
      size: 'xs',
      prepended: true,
      class: 'pl-1.5'
    },
    {
      size: 'sm',
      prepended: true,
      class: 'pl-2.5'
    },
    {
      size: 'md',
      prepended: true,
      class: 'pl-4'
    },
    {
      size: 'lg',
      prepended: true,
      class: 'pl-4'
    },
    {
      size: 'xl',
      prepended: true,
      class: 'pl-4'
    },
    // endregion Prepended Styles
    // region Appended Styles
    {
      size: 'xs',
      appended: true,
      class: 'pr-1.5'
    },
    {
      size: 'sm',
      appended: true,
      class: 'pr-2.5'
    },
    {
      size: 'md',
      appended: true,
      class: 'pr-4'
    },
    {
      size: 'lg',
      appended: true,
      class: 'pr-4'
    },
    {
      size: 'xl',
      appended: true,
      class: 'pr-4'
    }
    // endregion Appended Styles
  ],
  defaultVariants: {
    size: 'md',
    variant: 'filled'
  }
});
